export const store = {
    isAuth: false,
    token: null ,
    isError: false,
    isLoading: false,
    data: [],
    isDataLoading: false
}